var React = require('react');
var Extras = require('../../../data/extras.json');

var Frame = require('../../views/Frame');

var createSprite = require('../../../lib/createSprite');
var Utils = require('../../../lib/utils');

var SlotMachineAnimations = require('../../../animations/slotMachine');

var SlotMachine = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        render: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,

        size: React.PropTypes.string,
        title: React.PropTypes.string,
        role: React.PropTypes.string,
    },

    contextTypes: {
        cleanTint: React.PropTypes.number,
        minIntensity: React.PropTypes.number,
        maxIntensity: React.PropTypes.number,
        language: React.PropTypes.string,
    },

    sprites: null,
    timeline: null,
    audios: null,

    getDefaultProps: function()
    {
        return {
            size: 'small',
            // The keys for the extra texts
            title: 'brett',
            role: 'brett_title',
        };
    },

    render: function()
    {
        const texts = _.merge(this.props.texts, [
            {
                title: Extras[this.props.title].text[this.context.language],
                subtitle: Extras[this.props.role].text[this.context.language],
            },
        ]);

        return (
            <Frame
                {...this.props}
                className={'slot-machine slot-machine-'+this.props.size}
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onIntensityChanged={this.updateIntensity}
                texts={texts}
            />
        );
    },

    /*
        Frame callbacks
    */

    build: function(container, timeline) {
        this.sprites = {
            container,
        };
        this.timeline = timeline;

        this.buildObjects();
        this.animateObjects();
    },

    play: function() {
        // console.log('play');

        if (this.timeline !== null) {
            this.timeline.play();
        }

        if (this.audios !== null) {
            Object.keys(this.audios).map((audioKey) => {
                this.audios[audioKey].mute(false);
            });
        }
    },

    pause: function() {
        // console.log('pause machine');

        if (this.timeline !== null) {
            this.timeline.pause();
        }

        if (this.mainTimeline !== null) {
            this.mainTimeline.pause();
        }

        if (this.loopTimeline !== null) {
            // const tweens = TweenMax.getTweensOf(this.loopTimeline);
            // tweens.forEach((tween) => {
            //     tween.pause();
            // });
            // this.loopTimeline.pause();
        }

        if (this.audios !== null) {
            Object.keys(this.audios).map((audioKey) => {
                this.audios[audioKey].mute(true);
            });
        }
    },

    destroy: function()
    {
        if (this.loopTimeline !== null) {
            TweenMax.killTweensOf(this.loopTimeline);
            this.loopTimeline.removeCallback();
            this.loopTimeline.kill();
            this.loopTimeline = null
        }
        if (this.mainTimeline !== null) {
            TweenMax.killTweensOf(this.mainTimeline);
            this.mainTimeline.removeCallback();
            this.mainTimeline.kill();
            this.timeline = null;
        }

        if (this.timeline !== null) {
            this.timeline.removeCallback();
            this.timeline.kill();
            this.timeline = null;
        }

        // Object.keys(this.audios).forEach((audioKey) => {
        //     this.audios[audioKey].destroy();
        //     this.audios[audioKey] = null;
        // });

        Object.keys(this.audios).forEach((audioKey) => {
            this.audios[audioKey].mute(true);
            // this.audios[audioKey] = null;
        });

        if (this.sprites) {
            // console.log('kill sprites stamper', this.sprites);
            Object.keys(this.sprites).forEach(key => (
                TweenMax.killTweensOf(this.sprites[key])
            ));
        }
        this.sprites = null;
    },

    updateIntensity: function(prevIntensity)
    {
        var props = this.props;
        var state = this.state;
        var context = this.context;
        var sprites = this.sprites;

        var intensity = props.intensity
        prevIntensity = typeof prevIntensity !== 'undefined' ? prevIntensity : intensity;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;

        SlotMachineAnimations.setCharlesSlotMachinesIntensity(intensity);

        if (props.size !== 'big')
        {
            SlotMachineAnimations.setCharlesSlotMachineIntensityPosition(sprites.charlesSlotMachine, intensity)
        }
    },

    /*
        Basic methods
    */

    buildObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;

        var container = sprites.container;

        var objs = props.objs;

        if (props.size !== 'big')
        {
            var slotMachinePipeObj = objs.slotMachinePipe;
            var slotMachinePipe = sprites.slotMachinePipe = createSprite(slotMachinePipeObj);
            Utils.setSizeAndPositionFromRefSize(slotMachinePipe, props.width, props.height, slotMachinePipeObj);
            container.addChild(slotMachinePipe);
        }

        var charlesSlotMachine = sprites.charlesSlotMachine = SlotMachineAnimations.createCharlesSlotMachine({
            width: props.width,
            height: props.height,
            objs: objs,
            size: props.size,
            color: this.context.cleanTint,
        });
        container.addChild(charlesSlotMachine);

        this.audios = SlotMachineAnimations.getAudios();
    },

    animateObjects: function()
    {
        const timelines = SlotMachineAnimations.getCharlesSlotMachineTimeline(this.sprites.charlesSlotMachine);

        this.mainTimeline = timelines.mainTimeline;
        this.loopTimeline = timelines.loopTimeline;
        this.timeline.add(this.mainTimeline, 0);
        // this.timeline.add(this.loopTimeline, 0);

        // if (this.props.onAnimationReady)
        // {
        //     this.props.onAnimationReady(this.timeline);
        // }
    }
});

module.exports = SlotMachine;



// WEBPACK FOOTER //
// ./js/components/frames/_common/SlotMachine.jsx